// const findingDefaultLeads = {
//   "R/S : > 1": ["V1","V2"],
//   "Anterolateral MI": ["Lead I","aVL", "V3","V4","V5","V6"],
//   "Anteroseptal MI": ["V1","V2","V3","V4"],
//   "Antero - Apical MI": ["V2","V3","V4","V5","V6"],
//   "Anterior Wall MI": [ "V3", "V4"],
//   "Inferior MI": ["Lead II", "Lead III", "aVF"],
//   "Infero Lateral MI":["Lead II", "Lead III", "aVF","V5","V6"],
//   "Lateral Wall MI":["Lead I","aVL","V5","V6"],
//   "Left Bundle Branch Block (LBBB)":["V1","V2","V3","V4","V5","V6"],
//   "Right Bundle Branch Block (RBBB)":["V1","V2","V3","V4","V5","V6"]
// };

// export default findingDefaultLeads;

const findingDefaultLeads = [
  {
    _id: "65b8f1a1c1a4b001a1a20013",
    name: "R/S : > 1",
    leads: ["V1", "V2"]
  },
  {
    _id: "65b8f1a1c1a4b001a1a20028",
    name: "Anterolateral MI",
    leads: ["Lead I", "aVL", "V3", "V4", "V5", "V6"]
  },
  {
    _id: "65b8f1a1c1a4b001a1a20029",
    name: "Anteroseptal MI",
    leads: ["V1", "V2", "V3", "V4"]
  },
  {
    _id: "65b8f1a1c1a4b001a1a20030",
    name: "Antero - Apical MI",
    leads: ["V2", "V3", "V4", "V5", "V6"]
  },
  {
    _id: "65b8f1a1c1a4b001a1a20031",
    name: "Anterior Wall MI",
    leads: ["V3", "V4"]
  },
  {
    _id: "65b8f1a1c1a4b001a1a20032",
    name: "Inferior MI",
    leads: ["Lead II", "Lead III", "aVF"]
  },
  {
    _id: "65b8f1a1c1a4b001a1a20033",
    name: "Infero Lateral MI",
    leads: ["Lead II", "Lead III", "aVF", "V5", "V6"]
  },
  {
    _id: "65b8f1a1c1a4b001a1a20034",
    name: "Lateral Wall MI",
    leads: ["Lead I", "aVL", "V5", "V6"]
  },
  {
    _id: "65b8f1a1c1a4b001a1a20035",
    name: "Left Bundle Branch Block (LBBB)",
    leads: ["V1", "V2", "V3", "V4", "V5", "V6"]
  },
  {
    _id: "65b8f1a1c1a4b001a1a20036",
    name: "Right Bundle Branch Block (RBBB)",
    leads: ["V1", "V2", "V3", "V4", "V5", "V6"]
  },
   {
    _id: "65b8f1a1c1a4b001a1a20046",
    name: "Poor R-wave Progression",
    leads: ["V1", "V2", "V3", "V4", "V5", "V6"]
  }
];

export default findingDefaultLeads;
